import GalleryStyleDashboard from '../components/GalleryStyleDashboard/GalleryStyleDashboard';
import lettersIcon from '../images/LettersOfGratitudeThumbnail.jpg';
import tree from '../images/MyTreeOfGratitudeThumbnail.jpg';
import lettersOfCourage from '../images/LettersOfCourageThumbnail.jpeg';
import lettersOfOptimism from '../images/LettersOfOptimismThumbnail.jpeg';
import poster from '../images/SELPostersThumbnail.png';
import screenshotLettersOfGratitude from '../images/example-letters-of-gratitude.png';
import screenshotTreeOfGratitude from '../images/example-tree-of-gratitude.png';
import screenshotLettersOfOptimism from '../images/example-letters-of-optimism.png';
import screenshotLettersOfCourage from '../images/example-letters-of-courage.png';
import screenshotSELPoster from '../images/example-sel-posters.png';
import { Switch, useRouteMatch } from 'react-router-dom';
import AuthenticatedRoute from '../AuthenticatedRoute';
import Gallery from './Gallery';

export const ugcCategories: Record<string, Record<string, string>> = {
  LettersOfGratitude: {
    representativeImage: lettersIcon,
    screenshotImage: screenshotLettersOfGratitude,
    applicationFilter: 'myPeekaville/writeLetterGame',
    onClickUrl: '/gallery/LettersOfGratitude',
    title: 'Letters of Gratitude',
  },
  MyTreeOfGratitude: {
    representativeImage: tree,
    screenshotImage: screenshotTreeOfGratitude,
    applicationFilter: 'myPeekaville/playertreeofgratitude',
    onClickUrl: '/gallery/MyTreeOfGratitude',
    title: 'My Tree of Gratitude',
  },
  LettersOfOptimism: {
    representativeImage: lettersOfOptimism,
    screenshotImage: screenshotLettersOfOptimism,
    applicationFilter: 'myPeekaville/optimismLetterGame',
    onClickUrl: '/gallery/LettersOfOptimism',
    title: 'Letters of Optimism',
  },
  LettersOfCourage: {
    representativeImage: lettersOfCourage,
    screenshotImage: screenshotLettersOfCourage,
    applicationFilter: 'myPeekaville/courageLetterGame',
    onClickUrl: '/gallery/LettersOfCourage',
    title: 'Letters of Courage',
  },
  SELPoster: {
    representativeImage: poster,
    screenshotImage: screenshotSELPoster,
    applicationFilter: 'myPeekaville/posterGame',
    onClickUrl: '/gallery/SELPoster',
    title: 'SEL Posters',
  },
};

const GalleryDashboard = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <AuthenticatedRoute exact path={`${path}`}>
          <GalleryStyleDashboard categories={ugcCategories} />
        </AuthenticatedRoute>
        <AuthenticatedRoute path={`${path}/:ugcCategory`}>
          <Gallery />
        </AuthenticatedRoute>
      </Switch>
    </>
  );
};

export default GalleryDashboard;
